




















import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'

@Component

export default class ComponenteBackofficeFarmacia extends Vue {
  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }
}
